<template>
  <div class="game-info-wrapper">
    <div class="info-item" :class="{[gameInfo.kind]: true}">
      <span>{{ gameInfo.kind }}</span>
    </div>
    <div class="info-item">
      <span>{{ gameInfo.player }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    gameInfo: Object,
  },
};
</script>

<style scoped>
.game-info-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.info-item {
  /* border: 1px solid grey; */
  padding: 0 10px;
  border-radius: 50px;
  border: 1px solid grey;
}
.info-item:nth-child(1) {
  margin-right: 5px;
}
.info-item span {
  font: 12px/20px paybooc;
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 2px 0; */
  /* vertical-align: middle; */
}

.경쟁 {
  /* background-color: #db3960; */
  border: 1px solid #db3960;
  background-color: transparent;
}
.경쟁 span {
  color: #db3960;
}

.협동 {
  border: 1px solid #3e85fb;
  background-color: transparent;
}
.협동 span {
  color: #3e85fb;
}
.힐링 {
  border: 1px solid #45ab47;
  background-color: transparent;
}
.힐링 span {
  color: #45ab47;
}
.학습 {
  border: 1px solid #f18716;
  background-color: transparent;
}
.학습 span {
  color: #f18716;
}
</style>
